import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import api from "@/lib/api";
import { fmtEUR } from "@/lib/constants";
import { CheckCircle2, Loader2, ArrowRight } from "lucide-react";

export default function PaymentSuccess() {
    const [params] = useSearchParams();
    const sessionId = params.get("session_id");
    const [status, setStatus] = useState(null);
    const [tries, setTries] = useState(0);

    useEffect(() => {
        if (!sessionId) return;
        let cancelled = false;
        const poll = async () => {
            try {
                const { data } = await api.get(`/payments/status/${sessionId}`);
                if (cancelled) return;
                setStatus(data);
                if (data.payment_status !== "paid" && tries < 12) {
                    setTimeout(() => setTries((t) => t + 1), 2000);
                }
            } catch (_) {}
        };
        poll();
    }, [sessionId, tries]);

    const paid = status?.payment_status === "paid";
    return (
        <div>
            <Header />
            <div className="max-w-2xl mx-auto px-6 py-20 text-center">
                {paid ? (
                    <div className="fade-up">
                        <div className="mx-auto w-16 h-16 rounded-full bg-green-100 flex items-center justify-center mb-6">
                            <CheckCircle2 size={32} className="text-green-600" />
                        </div>
                        <h1 className="font-display text-4xl mb-3">Paiement confirmé</h1>
                        <p className="text-slate-500 mb-2">
                            Votre paiement de {fmtEUR(status.amount)} a été traité avec succès.
                        </p>
                        <p className="text-slate-500 mb-8 text-sm">
                            La mission est maintenant publiée auprès des professionnels correspondant à vos critères.
                            Vous recevrez les candidatures dans votre espace client.
                        </p>
                        <Link
                            to="/client"
                            className="btn-gold inline-block"
                            data-testid="success-goto-dashboard"
                        >
                            Accéder à mon espace client
                            <ArrowRight className="inline ml-2 -mr-1" size={18} />
                        </Link>
                    </div>
                ) : (
                    <div>
                        <Loader2
                            className="mx-auto animate-spin text-[#F5A623] mb-6"
                            size={40}
                        />
                        <h1 className="font-display text-3xl mb-3">
                            Confirmation du paiement...
                        </h1>
                        <p className="text-slate-500">
                            Merci de patienter quelques secondes.
                        </p>
                    </div>
                )}
            </div>
            <Footer />
        </div>
    );
}
